import axiosInstance from './axiosInstance';

export const userLogin = (username, password) =>
    axiosInstance.post("/User/UserLogin", { username, password });

export const isUserAuthenticated = () =>
    axiosInstance.get("/User/isUserAuthenticated");

export const getAllAgents = () =>
    axiosInstance.get("/User/GetAllAgents");

export const getAllAgentGroups = () =>
    axiosInstance.get("/User/GetAllAgentGroups");

export const getAgentDetailsByAgentId = (agentId) =>
    axiosInstance.get(`/User/GetAgentDetailsById?agentId=${agentId}`);

export const getAgentsByGroupId = (groupId) =>
    axiosInstance.get(`/User/GetAgentsByGroupId?groupId=${groupId}`);

export const updateUserPassword = (userId, currentPassword, newPassword) =>
    axiosInstance.put("/User/UpdateUserPassword", { userId, currentPassword, newPassword });
